/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ccsl_Export_Header_Title_NumberInputs */

const en_ccsl_export_header_title_number = /** @type {(inputs: Ccsl_Export_Header_Title_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TI #`)
};

const fr_ccsl_export_header_title_number = /** @type {(inputs: Ccsl_Export_Header_Title_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TI #`)
};

const de_ccsl_export_header_title_number = /** @type {(inputs: Ccsl_Export_Header_Title_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TI #`)
};

const it_ccsl_export_header_title_number = /** @type {(inputs: Ccsl_Export_Header_Title_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TI #`)
};

const ru_ccsl_export_header_title_number = /** @type {(inputs: Ccsl_Export_Header_Title_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ТИ #`)
};

const es_ccsl_export_header_title_number = /** @type {(inputs: Ccsl_Export_Header_Title_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TI #`)
};

const zh_cn2_ccsl_export_header_title_number = /** @type {(inputs: Ccsl_Export_Header_Title_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TI #`)
};

const ja_ccsl_export_header_title_number = /** @type {(inputs: Ccsl_Export_Header_Title_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TI #`)
};

const hi_ccsl_export_header_title_number = /** @type {(inputs: Ccsl_Export_Header_Title_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`टीआई #`)
};

const pt_pt2_ccsl_export_header_title_number = /** @type {(inputs: Ccsl_Export_Header_Title_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TI #`)
};

/**
* | output |
* | --- |
* | "TI #" |
*
* @param {Ccsl_Export_Header_Title_NumberInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ccsl_export_header_title_number = /** @type {((inputs?: Ccsl_Export_Header_Title_NumberInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ccsl_Export_Header_Title_NumberInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ccsl_export_header_title_number(inputs)
	if (locale === "de") return de_ccsl_export_header_title_number(inputs)
	if (locale === "it") return it_ccsl_export_header_title_number(inputs)
	if (locale === "ru") return ru_ccsl_export_header_title_number(inputs)
	if (locale === "es") return es_ccsl_export_header_title_number(inputs)
	if (locale === "zh-CN") return zh_cn2_ccsl_export_header_title_number(inputs)
	if (locale === "ja") return ja_ccsl_export_header_title_number(inputs)
	if (locale === "hi") return hi_ccsl_export_header_title_number(inputs)
	if (locale === "pt-PT") return pt_pt2_ccsl_export_header_title_number(inputs)
	return en_ccsl_export_header_title_number(inputs)
});